import { Typography } from "@suraasa/placebo-ui"
import { Theme } from "@suraasa/placebo-ui-legacy"
import clsx from "clsx"
import React, { useState } from "react"
import { createUseStyles } from "react-jss"
import Webcam from "react-webcam"

import shepherdClass from "../shepherdClasses"
import WebcamComponent from "./_components/webcam"

type Props = {
  videoRef: React.RefObject<Webcam>
}

const useStyles = createUseStyles((theme: Theme) => ({
  wrapper: {
    backgroundColor: theme.colors.onSurface[800],
    padding: theme.spacing(1.5, 5),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(1.5, 3),
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1.5, 2),
    },
  },
  white: {
    color: theme.colors.common.white[500],
  },
  midnight: {
    color: theme.colors.onSurface[800],
  },
  cameraOn: {
    height: 22,
    width: 50,
    borderRadius: 33,
    backgroundColor: theme.colors.common.white[500],
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  greenDot: {
    animation: `blink 2s infinite`,
    height: 12,
    width: 12,
    backgroundColor: theme.colors.success[400],
    borderRadius: "50%",
  },
  barWidth: {
    width: "15vw",
  },
  divider: {
    backgroundColor: theme.colors.onSurface[200],
    border: `1px solid ${theme.colors.onSurface[200]} `,
    borderRadius: 2,
    height: "100%",
  },
  animation: {
    transition: "height 0.2s ease",
    height: "190px",
    overflow: "hidden",
    [theme.breakpoints.down("xs")]: {
      height: "160px",
    },
  },
  shrink: {
    height: "46px",
  },
}))

const CPATWebcam = ({ videoRef }: Props) => {
  const classes = useStyles()
  const [openDrawer, toggleOpenDrawer] = useState(false)

  const cameraOn = (
    <div
      className={clsx(
        classes.white,
        shepherdClass["cameraContainer"],
        "grid grid-flow-col items-center gap-0.75"
      )}
    >
      <Typography variant="strongSmallBody">Camera</Typography>
      <span className={clsx(classes.cameraOn, classes.midnight)}>
        <Typography variant="strongSmallBody">On</Typography>
        <span className={clsx(classes.greenDot, "ml-0.5")} />
      </span>
    </div>
  )

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      className={clsx(
        "mt-0.75 flex flex-col",
        classes.animation,
        classes.wrapper,
        {
          "justify-center": openDrawer,
          [classes.shrink]: !openDrawer,
        }
      )}
      onClick={() => toggleOpenDrawer(prev => !prev)}
      onBlur={() => toggleOpenDrawer(false)}
      role="button"
      tabIndex={0}
    >
      <div
        className={clsx(
          "grid grid-flow-col items-center justify-between gap-1"
        )}
      >
        {!openDrawer && <>{cameraOn}</>}
      </div>
      <div
        style={{
          height: openDrawer ? "auto" : "1px !important",
          visibility: openDrawer ? "visible" : "hidden",
        }}
      >
        <WebcamComponent videoRef={videoRef} />
      </div>
    </div>
  )
}

export default React.memo(CPATWebcam)
